import {
    CONFIRMED_GET_LEAD_NOTES,
    CONFIRMED_CREATE_LEAD_NOTE_ACTION,
  } from "../actions/LeadNotetype";
  
  const initialState = {
    notes: [],
    isLoading: false,
    error: null,
  };
  
  export default function LeadNotesReducer(state = initialState, action) {
    switch (action.type) {
      case CONFIRMED_GET_LEAD_NOTES:
        return {
          ...state,
          notes: action.payload,
          isLoading: false,
          error: null,
        };
  
      case CONFIRMED_CREATE_LEAD_NOTE_ACTION:
        return {
          ...state,
          notes: [...state.notes, action.payload],
          isLoading: false,
          error: null,
        };
  
      default:
        return state;
    }
  }
  